import { useEffect, useRef } from "react";
import "./NavigationTabs.css";
import { navigateToLandingPage } from "utilities/js/NavigationHelper";
import Constants from "utilities/js/Constants";
import getURLParam from "utilities/js/ParameterRetrieval";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getNotifications } from "utilities/js/callouts/CalloutFactory";
import CookieManager from "utilities/js/localstorage/CookieManager";
import { isLoggedIn } from "utilities/js/ActionLibrary";

const homeIcon = Constants.ICON_HOME;
const communityIcon = Constants.ICON_COMMUNITY;
const personalIcon = Constants.ICON_PERSONAL;
const personalNotificationIcon = Constants.ICON_PERSONAL_NOTIFICATION;

const NavigationTabs = props => {

    const cookieManager = new CookieManager();
    const navTabsRef = useRef();
    const navigate = useNavigate();
    const notificationResponse = useQuery({
        queryKey: ['unreadNotifications'],
        queryFn: () => getNotifications({readStatus: false}),
        staleTime: Infinity,
        enabled: isLoggedIn()
    })

    useEffect(() => {
        let urlScreen = getURLParam(Constants.SCREEN_PARAMETER_NAME)
        let defaultScreen = urlScreen;// ? urlScreen : Constants.SCREEN_NAME_HOME;
        if(defaultScreen){
            let defaultTab = navTabsRef.current.querySelector(".brackset-navigation-tab[data-name='"+ defaultScreen + "']");
            if (defaultTab) {
                defaultTab.classList.add("selected");
            }
        }
    }, [])

 
    function clearAllSelectedClasses(){
        let tabs = navTabsRef.current.querySelectorAll('.brackset-navigation-tab');
        tabs.forEach(tab => {
            tab.classList.remove("selected");
        })
    }

    function openHomeScreen(event){
        clearAllSelectedClasses();
        event.currentTarget.classList.add("selected");

        if(props.onHomeClick){
            props.onHomeClick(); 
        }else{
            navigateToLandingPage({routerNav: navigate, defaultScreen:'Home'});
        }
    }
    function openCommunityScreen(event){
        clearAllSelectedClasses();
        event.currentTarget.classList.add("selected");

        if(props.onCommunityClick){
            props.onCommunityClick(); 
        }else{
            navigateToLandingPage({routerNav: navigate, defaultScreen:'Community'});
        }
    }
    function openPersonalScreen(event){
        clearAllSelectedClasses();
        event.currentTarget.classList.add("selected");

        if(props.onPersonalClick){
            props.onPersonalClick(); 
        }else{
            navigateToLandingPage({routerNav: navigate, defaultScreen:'Personal'});
        }
    }

    function getTabContainerClass(){
        let className = "brackset-navigation-tab-container";
        if(props.hideDesktop){
            className += " hide-desktop";
        }
        if(props.hideMobile){
            className += " hide-mobile";
        }

        if(props.isVertical){
            className += " vertical";
        }
        return className;
    }

    function getPersonalLink(){        
        if(notificationResponse.data && notificationResponse.data.length > 0){
            return (
            <div className="brackset-navigation-tab" data-name={Constants.SCREEN_NAME_PERSONAL} onClick={openPersonalScreen}>
                <img className="brackset-navigation-icon" src={personalNotificationIcon} alt="home-button"></img>
            </div>
            )
        }else{
            return (
            <div className="brackset-navigation-tab" data-name={Constants.SCREEN_NAME_PERSONAL} onClick={openPersonalScreen}>
                <img className="brackset-navigation-icon" src={personalIcon} alt="home-button"></img>
            </div>
            )
        }
    }

    function getVerticalNavigationTabs(){
        return (<div className={getTabContainerClass()}>
            <div className="brackset-navigation-tabs" ref={navTabsRef}>
                <div className="brackset-navigation-tab" data-name={Constants.SCREEN_NAME_HOME} onClick={openHomeScreen}>
                    <img className="brackset-navigation-icon" src={homeIcon} alt="home-button"></img> Home
                </div>
                <div className="brackset-navigation-tab" data-name={Constants.SCREEN_NAME_COMMUNITY} onClick={openCommunityScreen}>
                    <img className="brackset-navigation-icon" src={communityIcon} alt="home-button"></img> Community
                </div>
                <div className="brackset-navigation-tab" data-name={Constants.SCREEN_NAME_PERSONAL} onClick={openPersonalScreen}>
                    <img className="brackset-navigation-icon" src={personalIcon} alt="home-button"></img> Personal
                </div>
            </div>
        </div>);
    }

    function getHorizontalNavigationTabs(){

        return (<>
            <div className={getTabContainerClass()}>
                <div className="brackset-navigation-tabs" ref={navTabsRef}>
                    <div className="brackset-navigation-tab" data-name={Constants.SCREEN_NAME_HOME} onClick={openHomeScreen}>
                        <img className="brackset-navigation-icon" src={homeIcon} alt="home-button"></img>
                    </div>
                    <div className="brackset-navigation-tab" data-name={Constants.SCREEN_NAME_COMMUNITY} onClick={openCommunityScreen}>
                        <img className="brackset-navigation-icon" src={communityIcon} alt="home-button"></img>
                    </div>
                    {getPersonalLink()}
                </div>
            </div>

        </>)
    }

    if(props.isVertical){
        return getVerticalNavigationTabs();
    }

    return getHorizontalNavigationTabs();
    
}

export default NavigationTabs;
